import React, { useEffect } from 'react';
import bemClassNames from '@enrise/bemclassnames';
import PlayingFieldRow from './PlayingFieldRow';
import './PlayingField.scss';
import { useGameState } from '~state/game';
import { useMovesState } from '~state/moves';

const cn = bemClassNames('PlayingField');

const PlayingField = () => {
  const [{ height: nrOfRows, players }, setGameState] = useGameState();

  const [moves] = useMovesState();

  const getNextPlayer = (currentPlayer: number) => {
    const nrOfPlayers = players.length;
    const nextPlayer = currentPlayer + 1 < nrOfPlayers ? currentPlayer + 1 : 0;
    return nextPlayer;
  };

  useEffect(() => {
    if (!moves.length) {
      return;
    }
    const lastMove = moves[moves.length - 1];
    const nextPlayer = lastMove?.playerConquered
      ? lastMove.player
      : getNextPlayer(lastMove.player);
    setGameState((previousState) => ({
      ...previousState,
      currentPlayerId: nextPlayer,
    }));
  }, [moves]);

  const rows = [];
  for (let rowNr = 0; rowNr <= nrOfRows; rowNr++) {
    const lastRow = rowNr === nrOfRows;
    rows.push(<PlayingFieldRow lastRow={lastRow} rowNr={rowNr} key={rowNr} />);
  }

  return <div className={cn()}>{rows}</div>;
};

export default PlayingField;
